import { render } from "./formTemplate.vue?vue&type=template&id=4110aed4&scoped=true"
import script from "./formTemplate.js?vue&type=script&lang=js"
export * from "./formTemplate.js?vue&type=script&lang=js"

import "./formTemplate.vue?vue&type=style&index=0&id=4110aed4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4110aed4"]])

export default __exports__